import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const BD100NavbarWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-bottom: 32px !important;

  padding: 0px 48px;

  position: sticky;
  top: 64px;

  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  z-index: 99;

  ${BREAKPOINTS.tablet} {
    top: 0px;
  }

  ${BREAKPOINTS.mobile} {
    padding: 0px 20px;
    margin-bottom: 24px !important;
  }
`;

export const BD100NavbarContainer = styled.div`
  width: 70vw;
  max-width: 1440px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 12px 0px 0px 0px;
  margin: 0 auto;

  & > :not(:last-child) {
    margin-right: 24px;
  }

  ${BREAKPOINTS.tablet} {
    width: 100%;
  }

  position: relative;
`;

export const BD100NavbarItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;

  ${BREAKPOINTS.tablet} {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: auto;
  }

  overflow: hidden;
`;

interface BD100NavbarItemProps {
  current?: boolean;
}

export const BD100NavbarItem = styled.span<BD100NavbarItemProps>`
  display: flex;
  align-items: center;

  gap: 8px;

  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  letter-spacing: 1.6px;
  text-transform: uppercase;

  padding: 8px 0px 16px 0px;

  color: ${({ current }) => (current ? '#171C33' : 'rgba(31, 32, 37, 0.5)')};

  ${({ current }) => current && `border-bottom: 2px solid #171C33;`}

  white-space: nowrap;

  cursor: pointer;
`;
